import React from 'react';
import styled from 'styled-components';
import TextField from '@clasohlson/co-ui-components/TextField';

const StyledTextfield = styled(TextField)`
  height: 38px;
  line-height: 38px;
  border: solid 1px #d9d5d5;
  font-size: 12px;
  &:focus {
    border: 1px solid #2d8ac0;
  }
`;

const TextFieldWrapper = styled.div`
  .co-input-error {
    font-size: 9px;
  }
  > div {
    width: 100%;
  }
`;

export const CustomTextfield = (props: any) => {
  const { forwardRef } = props;
  return (
    <TextFieldWrapper>
      <StyledTextfield {...props} ref={forwardRef} />
    </TextFieldWrapper>
  );
};
